/** Drafting API endpoints, merged into the platform API client. */
export const assistApiEndpoints: Record<string, string> = {
  assistModel: "/ext/assist/model/",
  setAssistModel: "PUT:/ext/assist/model/",
  removeAssistModel: "DELETE:/ext/assist/model/",
  checkAssistModel: "POST:/ext/assist/model/check/",
  draftProject: "POST:/ext/assist/draft/",
  chooseAssistModel: "PUT:/ext/assist/choose/",
  buyAssistCredits: "POST:/ext/assist/credits/",
  platformAssistModel: "/ext/assist/platform/model/",
  platformAssistUse: "/ext/assist/platform/use/",
  setPlatformAssistTerms: "PUT:/ext/assist/platform/model/",
  savePlatformAssistModel: "POST:/ext/assist/platform/model/",
  removePlatformAssistModel: "DELETE:/ext/assist/platform/model/",
};
